// import { Amplify } from 'aws-amplify';

import { Amplify } from 'aws-amplify';

import stageConfig from './config/stage';
import prodConfig from './config/prod';

/**
 * Supply configuration information to the Amplify
 */
export function configureAmplify() {
  let amplifyConfig = prodConfig;
  if (process.env.APP_ENV !== 'prod') {
    amplifyConfig = stageConfig;
  }
  const revisionedAmplifyAwsExports = {
    ...amplifyConfig,
    aws_user_files_s3_bucket: process.env.S3_BUCKET,
    aws_user_files_s3_bucket_region: 'us-west-2',
  };
  Amplify.configure(revisionedAmplifyAwsExports);
}
